import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { Button, NativeSelect, Paper, Checkbox } from "@material-ui/core";
import MaterialTable from "material-table";
import * as S from "./styles";
import api from "../../../../services/api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useMessageBox } from "../../../../context/MessageBox";
import * as FormStyle from "./formStyle";
import { capitalizeFirstLetter } from "../../../../utils/functions";

function OperationsMiddle({
  setTableData,
  setTotalTableData,
  setIsLoading,
  isLoading,
  triggerUpdate,
  setTriggerUpdate,
  scheduleDate,
  setScheduleDate,
  showFechamento,
  setShowFechamento,
  selectedItens,
  setSelectedItens,
}) {
  const classes = FormStyle.useStyles();
  const [screenParams, setScreenParams] = useState({
    title: "Fechamento Mensal",
    apiTable: "AncorasFechamentosMeses/ConsultarDadosFechamento",
    fechamentoMensal: "AncorasFechamentosMeses/ExecutarFechamentoMes",
    dateFormat: "MM/yyyy",
  });
  const { setMessageData } = useMessageBox();
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [finishModal, setFinishModal] = useState(false);

  useEffect(async () => {
    if (triggerUpdate) {
      await getInfoForForm();
    }
  }, [scheduleDate]);

  const getInfoForForm = async () => {
    const dateFilter = new Date(scheduleDate);
    const model = {
      anoReferencia: dateFilter.getFullYear(),
      mesReferencia: dateFilter.getMonth() + 1,
    };

    setIsLoading(true);
    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        setTableData([]);
        setTotalTableData({});
      } else {
        setTableData(relatorio.data.resposta?.listaAncorasFechamentosMes);
        setTotalTableData(relatorio.data.resposta);
        setShowFechamento(
          relatorio.data.resposta.mostrarBotaoExecutarFechamento
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFechamentos = async () => {
    setIsLoading(true);
    const dateFilter = new Date(scheduleDate);
    let model = {
      ancoraId: 0,
      anoReferencia: dateFilter.getFullYear(),
      mesReferencia: dateFilter.getMonth() + 1,
    };
    try {
      for (let index = 0; index < selectedItens.length; index++) {
        setShowModal(true);
        setModalText(
          `Realizando Fechamento da rede ${selectedItens[index].rede}`
        );
        model.ancoraId = selectedItens[index].ancoraId;
        const response = await api.post(screenParams.fechamentoMensal, model);
        if (response.data.status == "Sucesso") {
          toast.success(
            "Fechamento da rede " + selectedItens[index].rede + " realizado"
          );
          if (index == selectedItens.length - 1) {
            setModalText(
              "Fechamentos realizados com sucesso!"
            );
            setFinishModal(true);
            setIsLoading(false);
          }
        } else {
          setModalText("Fechamentos Abortados, feche o box para continuar");
          setFinishModal(true);
          index = selectedItens.length;
          toast.error("Fechamentos Abortados");
          setIsLoading(false);
        }
      }
    } catch (ex) {
      setModalText("Fechamentos Abortados, feche o box para continuar");
      setFinishModal(true);
      index = selectedItens.length;
      toast.error("Fechamentos Abortados por erro ocorrido");
      console.log(ex);
    }
    finally{
      setIsLoading(false);
    }
  };

  const handleFechamentoModal = () => {
    setFinishModal(false);
    setSelectedItens([]);
    getInfoForForm();
    setShowModal(false);
  };

  return (
    <>
      <div style={{ height: "100%" }}>
        <div
          className="new-body-schedule"
          style={{
            justifyContent: showFechamento ? "space-between" : 'center',
            display: "flex",
            marginTop: "20px",
            alignItems: "center",
          }}>
          <p></p>
          <div style={{ display: "flex", alignItems: "center" , width: showFechamento ? "0%" : "11%" }}>
            <div className='schedule-input'
              style={{ display: 'flex', marginTop: '8px', alignItems: 'center',  flexDirection: 'column'}}
            >
              <span className={classes.label}>Mes de Referência</span>
              <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                style={{
                  minWidth: "20px",
                  width: "20px",
                  height: "23px",
                  paddingLeft: "20px",
                }}
                onClick={() => {
                  const newDate = new Date(scheduleDate);
                  setScheduleDate(newDate.setMonth(newDate.getMonth() - 1));
                  setTriggerUpdate(true);
                }}
              >
                🢀
              </Button> 

              <div
                style={{ padding: "0px 5px", maxWidth: "150px", height: "23px" }}
              >
                <DatePicker
                  style={{ width: "145px" }}
                  selected={scheduleDate}
                  onChange={(date) => {
                    setScheduleDate(date);
                    setTriggerUpdate(true);
                  }}
                  dateFormat={screenParams.dateFormat}
                  locale="ptBR"
                />
              </div>

              <Button
                style={{ minWidth: "20px", width: "20px", height: "23px" }}
                onClick={() => {
                  const newDate = new Date(scheduleDate);
                  setScheduleDate(newDate.setMonth(newDate.getMonth() + 1));
                  setTriggerUpdate(true);
                }}
              >
                🢂
              </Button>
            </div></div>
          </div>
          {showFechamento && (
            <div
              style={{ display: "flex", alignItems: "center", height: "60px" }}
            >
              <Button
                color="primary"
                variant="contained"
                style={{ marginRight: "10px" }}
                disabled={isLoading || selectedItens.length == 0}
                onClick={handleFechamentos}
              >
                Enviar Fechamento
              </Button>
            </div>
          )}
        </div>
      </div>
      <S.DialogModal
        open={showModal}
        onClose={() => {}}
        disableEscapeKeyDown
        className="dialog-parent"
      >
        <S.DialogContainer>
          <div className="margin-container">
            <S.Title>Fechamentos</S.Title>
            <div style={{ padding: "10px", textAlign: "center" }}>
              {modalText}
            </div>
            <S.DialogActionsMessage>
              {finishModal && (
                <Button
                  onClick={handleFechamentoModal}
                  style={{
                    backgroundColor: "rgb(35, 45, 100)",
                    fontWeight: "400",
                    color: "#fff",
                  }}
                >
                  Fechar
                </Button>
              )}
            </S.DialogActionsMessage>
          </div>
        </S.DialogContainer>
      </S.DialogModal>
    </>
  );
}

export default OperationsMiddle;
